var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewWindow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 1h1v22H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 22h15v1H0zm7.765-3.765.707.707L22.614 4.8l-.707-.707z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.425 12.025h1v-7h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.681 5.282v-1h7v1zM0 0h15v1H0z"
}))));
export default SvgNewWindow;